let base;

// See README.md for API URL configuration documentation
// This file runs at build-time, so process.env.VUE_APP_ENV_NAME is available
const envName = process.env.VUE_APP_ENV_NAME || 'development';

// Check for direct API base URL override, otherwise use environment-specific URLs
if (process.env.VUE_APP_API_BASE_URL) {
  base = process.env.VUE_APP_API_BASE_URL;
} else {
  const domainsByEnvironment = {
    production: 'https://finantzak-api.recorrido.cl',
    qa: 'https://finantzak-qa-api.recorrido.cl',
    staging: 'http://finance-api-staging.recorrido.cl',
  };

  base = domainsByEnvironment[envName] || 'http://localhost:4000';
}

const apiWsUrl = `${process.env.VUE_APP_API_WS_PROTOCOL || 'ws'}://${base.replace(/^https?:\/\//, '')}/websocket`;

export default {
  BASE: base,
  API_URL: `${base}/api/v1`,
  API_WEBSOCKET_URL: apiWsUrl,
};
